module.exports = __webpack_public_path__ + "img/D5.9bd237c2.png";